import Navbar from "./components/Navbar";
import TickerBar from "./components/TickerBar";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import Featured from "./components/Featured";
import Leak from "./components/Leak";
import GodPosts from "./components/GodPosts";
import Channels from "./components/Channels";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="w-full bg-background-50 text-foreground-950">
      <TickerBar />
      <Navbar />
      <main>
        <Hero />
        <HotRank />
        <Featured />
        <Leak />
        <GodPosts />
        <Channels />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}